// src/pages/AdminOrders.jsx
import React, { useEffect, useState } from "react";
import { notifyError, notifySuccess } from "../utils/notify";

const API_URL = "http://127.0.0.1:8000/api/orders/";

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Fetch all orders
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await fetch(API_URL);
        const data = await res.json();
        // Extract the results array from paginated response
        setOrders(Array.isArray(data.results) ? data.results : []);
      } catch (err) {
        notifyError("Failed to load orders", "Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  // ✅ Update order status
  const handleStatusChange = async (id, status) => {
    try {
      const res = await fetch(`${API_URL}${id}/update/`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status }),
      });

      if (!res.ok) throw new Error("Failed to update");

      notifySuccess("Updated", "Order status updated.");
      setOrders((prev) =>
        prev.map((order) =>
          order.id === id ? { ...order, status } : order
        )
      );
    } catch (err) {
      notifyError("Update failed", "Could not update order status.");
    }
  };

  if (loading)
    return (
      <div className="text-center mt-20 text-gray-400 text-xl">
        Loading orders...
      </div>
    );

  return (
    <div className="min-h-screen bg-gray-900 pt-24 px-6 text-white">
      <h1 className="text-3xl font-bold text-teal-400 mb-6">
        🧾 Order Dashboard
      </h1>

      {orders.length === 0 ? (
        <p className="text-gray-400">No orders found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-gray-800 rounded-xl border border-gray-700">
            <thead>
              <tr className="bg-teal-700 text-left">
                <th className="py-3 px-4">Order ID</th>
                <th className="py-3 px-4">Customer</th>
                <th className="py-3 px-4">Total</th>
                <th className="py-3 px-4">Status</th>
                <th className="py-3 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id} className="border-t border-gray-700">
                  <td className="py-3 px-4">{order.id}</td>
                  <td className="py-3 px-4">{order.shipping_address}</td>
                  <td className="py-3 px-4">£{order.total_amount}</td>
                  <td className="py-3 px-4">{order.status}</td>
                  <td className="py-3 px-4">
                    <select
                      value={order.status}
                      onChange={(e) =>
                        handleStatusChange(order.id, e.target.value)
                      }
                      className="bg-gray-700 text-white rounded-md p-2"
                    >
                      <option>Processing</option>
                      <option>Shipped</option>
                      <option>Delivered</option>
                      <option>Cancelled</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminOrders;
